module.exports = "../images/docs.png";


//////////////////
// WEBPACK FOOTER
// ./src/client/images/docs.png
// module id = 911
// module chunks = 1